/**
 * @param text The text to search for matches
 * @param matchString The match string to replace with strong text
 * @returns The text with strong text for all matches, case insensitive
 */
/*
  This chars will throw an exception if we don't parse it
 */
const invalidCharsForRegex = /([.?*+^$[\]\\(){}|-])/g;
/*
  valid string to be used in regex
 */

const parsedValidCharacters = '\\$1';
export const getEmphasizedTextHtml = (text: string, matchString: string) => {
  /*
    Check is need to avoid crash when entering chars like "("
  */
  const validText = matchString.replaceAll(
    invalidCharsForRegex,
    parsedValidCharacters,
  );

  const regex = new RegExp(validText, 'gi');
  return text.replaceAll(regex, (match) => `<strong>${match}</strong>`);
};
